import { Utils } from './utils';
import { Verbs } from './constants/verbs';
import { About } from './classes/about';
import { Activity } from './classes/activity';
import { Agent } from './classes/agent';
import { Context } from './classes/context';
import { Group } from './classes/group';
import { Result } from './classes/result';
import { Score } from './classes/score';
import { Statement } from './classes/statement';
import { Verb } from './classes/verb';
import { svc } from './support/svc';
export class XAPI {
    static Verbs = Verbs;
    static getUUID = Utils.getUUID;
    static calculateISO8601Duration = Utils.calculateISO8601Duration;
    static getISODateString = Utils.getISODateString;
    static About = About;
    static Activity = Activity;
    static Agent = Agent;
    static Context = Context;
    static Group = Group;
    static Result = Result;
    static Score = Score;
    static Statement = Statement;
    static Verb = Verb;
    static svc = svc;
}
